export const body = {
    border: "1px solid black",
    padding: "10px",
    cursor: "pointer"
};
export const bottomBox = {
    border: "1px solid black",
    textAlign: "center"
};

export const bodyWithoutPointer = {
    border: "1px solid black",
    padding: "10px"
};

export const image = {
    height: "150px",
    width: "150px",
    border: "1px solid black",
    backgroundRepeat: "no-repeat",
    backgroundSize: "150px 150px",
    position: "relative"
};

export const square = {
    position: "absolute",
    width: "40px",
    height: "20px",
    backgroundColor: "grey",
    bottom: -10,
    right: -20,
    borderRadius: "25px",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

export const columnRight = {
    textAlign: "right",
    alignSelf: "flex-end"
};

export const redText = {
    color: "red"
};

export const customTitle = {
    textDecoration: "underline"
};

export const middleColumn = {
    color: "red"
};

export const repaidItem_columnRight = {
    textAlign: "right"
};

//MOBILE
export const mobile_body = {
    padding: "5px",
    border: "1px solid black",
    margin: "2%",
    width: "96%",
    display: "flex",
    flexDirection: "row",
    cursor: "pointer"
};

export const mobile_imageContainer = {
    // border: "1px solid red",
    width: "150px"
};

export const mobile_infoContainer = {
    // border: "1px solid blue",
    flex: "1" //Fills the remaining space<<<!!!
};

export const mobile_orderRefs = {
    paddingLeft: "5px",
    // border: "1px solid black",
    width: "100%"
};

export const mobile_totals = {
    textAlign: "right"
    // border: "1px solid black"
};

export const mobile_square = {
    position: "absolute",
    width: "40px",
    height: "20px",
    backgroundColor: "grey",
    bottom: -5,
    right: -20,
    borderRadius: "25px",
    color: "white",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
};

export const mobile_itemBody = {
    padding: "5px",
    border: "1px solid black",
    margin: "2%",
    width: "96%"
};

export const flexRow = {
    display: "flex",
    flexDirection: "row"
};

export const moobile_itemTotalsHeadings = {
    textAlign: "right",
    flex: "1"
};

export const mobile_itemTotals = {
    paddingLeft: "5px"
};
